export default {
    ANTROPOMETRIA : 20,
    APLICACAO_TOPICA_DE_FLUOR : 2,
    DESENVOLVIMENTO_DA_LINGUAGEM : 23,
    ESCOVACAO_DENTAL_SUPERVISIONADA : 9,
    PRÁTICAS_CORPORAIS_E_ATIVIDADE_FISICA : 11,
    PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_1 : 25,
    PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_2 : 26,
    PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_3 : 27,
    PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_4 : 28,
    SAUDE_AUDITIVA : 22,
    SAUDE_OCULAR : 3,
    VERIFICACAO_DA_SITUACAO_VACINAL : 24,
    OUTRAS : 12,
    OUTRO_PROCEDIMENTO_COLETIVO : 30,
    FORNECIMENTO_DE_KIT_BUCAL : 33,
    PNCT_MANUTENCAO : 34,
}